export default __webpack_public_path__ + "static/media/Tick.21405c50.svg";